var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 60,
    viewBox: "0 0 62 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0761719,
    width: 62,
    height: 59.3768,
    rx: 10,
    fill: "#009999"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1560_55893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1762 12.2715C27.1509 12.2715 21.8182 15.0821 18.5903 19.3712C19.2583 19.7785 19.9095 20.3369 20.5393 21.0549C22.9474 17.6903 26.8411 15.3297 31.3461 14.8222L33.176 17.7157L35.0058 14.8221C41.9308 15.602 47.4353 20.7452 48.2702 27.216L45.1732 28.9261L48.2703 30.6363C47.7121 34.9625 45.0606 38.687 41.299 40.9193C41.5386 41.4297 41.6736 41.9515 41.6974 42.4896C41.715 42.8828 41.6716 43.2543 41.5843 43.607C47.1836 40.7957 51 35.2704 51 28.9264C51 19.7426 43.0045 12.2715 33.1762 12.2715ZM37.7247 39.7005C33.6158 36.6149 32.4669 38.1317 30.6026 39.8735C29.301 41.0901 26.0073 38.5495 23.1633 35.8919C20.3191 33.234 17.6007 30.1567 18.9022 28.9403C20.7666 27.1985 22.3894 26.1242 19.0863 22.2859C15.7843 18.4462 13.5831 21.3941 11.7772 23.0817C9.69223 25.0293 11.6673 32.287 19.3438 39.4612C27.0213 46.6343 34.7884 48.4787 36.8721 46.5319C38.6779 44.8442 41.8336 42.7876 37.7247 39.7005ZM25.2109 31.5328C25.2109 28.1201 29.4867 27.5121 29.4867 26.1803C29.4867 25.5341 28.9331 25.2628 28.4211 25.2628C27.4801 25.2628 26.9548 26.245 26.9548 26.245L25.156 25.1204C25.156 25.1204 26.0693 23.1294 28.6427 23.1294C30.2614 23.1294 32.0185 23.9957 32.0185 25.9607C32.0185 28.8439 28.0337 29.4 27.9644 30.5894H32.1709V32.5286H25.3218C25.2524 32.1666 25.2109 31.8436 25.2109 31.5328ZM33.1824 28.9216L37.0017 23.2843H39.9625V28.4173H41.1384V30.2917H39.9625V32.5287H37.5685V30.2917H33.1825V28.9216H33.1824ZM37.5685 28.4172V26.3486C37.5685 25.8443 37.6516 25.314 37.6516 25.314H37.6239C37.6239 25.314 37.4166 25.8831 37.1396 26.271L35.6457 28.3915V28.4174L37.5685 28.4172Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1560_55893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 37.3768,
    fill: "white",
    transform: "translate(11 11.0762)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/Icon-7.c36b97a1ecafac3f20988d292723fe57.svg";
export { ForwardRef as ReactComponent };